export default __webpack_public_path__ + "static/media/YAS0580.34I-30576_-17597_0.84b5e5ff.jpg";